import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Container,
  TextField,
  CardContent,
  Divider,
} from "@mui/material";
import api from "../../globals/axios";
import { useParams } from "react-router-dom";
import CustomAppBar from "../../components/AppBar";
import { StyledCard } from "../farmer/Harvests";

export const HarvestSalesCards = ({ sales }) => {
  return (
    <div style={{ marginTop: "10px" }}>
      {sales.map((sale) => (
        <StyledCard key={sale.id} sx={{ my: 3, borderRadius: 3 }} elevation={2}>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
              Sold To: {sale.sold_to}
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              Quantity: {sale.quantity} kgs
            </Typography>
          </CardContent>
        </StyledCard>
      ))}
    </div>
  );
};

export default function ViewAdvisoryQuestion() {
  const { harvestId } = useParams();

  console.log("token_code", harvestId);

  const [tokenData, setTokenData] = useState({
    farm_name: "",
    area: "",
    regulator: "",
    pin_code: "",
    irrigation_source: "",
  });

  const loadNFT = async () => {
    let res = await api.get(`/farmer/harvests/${harvestId}`);
    const data = res.data;
    setTokenData(data);
  };

  useEffect(() => {
    loadNFT();
  }, [harvestId]);

  return (
    <>
      <CustomAppBar title="View Harvest" />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            // spacing={1}
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <TextField
              margin="normal"
              fullWidth
              label="Farm Name"
              InputProps={{
                readOnly: true,
              }}
              value={tokenData.crop?.farmland?.farm_name || ""}
            />
            <TextField
              margin="normal"
              fullWidth
              label="Crop Type"
              InputProps={{
                readOnly: true,
              }}
              value={tokenData.crop?.crop_type || ""}
            />
            <TextField
              margin="normal"
              fullWidth
              label="Harvest Date"
              InputProps={{
                readOnly: true,
              }}
              value={tokenData.harvest_date || ""}
            />
            <TextField
              margin="normal"
              fullWidth
              label="Quantity"
              InputProps={{
                readOnly: true,
              }}
              value={tokenData.quantity || ""}
            />

            {tokenData.picture && (
              <Typography color="textSecondary" gutterBottom>
                Picture:{" "}
                <a href={tokenData.picture} target="_blank" rel="noreferrer">
                  View
                </a>
              </Typography>
            )}
            {tokenData.weigh_bridge_receipt && (
              <Typography color="textSecondary" gutterBottom>
                Weigh Bridge Receipt:{" "}
                <a href={tokenData.weigh_bridge_receipt} target="_blank" rel="noreferrer">
                  View
                </a>
              </Typography>
            )}

            <Divider />
            <Box sx={{ m: 2 }}>
              <Typography variant="h6">Sales</Typography>
              {tokenData.sales ? (
                <HarvestSalesCards sales={tokenData.sales} />
              ) : (
                <Typography>No sales added</Typography>
              )}
            </Box>

            {/* Add an image with QR code to the current page */}
            {/* <img 
          width={200} height={200}
          src={`https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=${window.location.href}`} alt="" /> */}

            {/* <Button
            style={{ marginTop: 10 }}
            variant="contained"
            size="small"
            color="primary"
            onClick={loadNFT}>Create NFT
          </Button> */}
          </Grid>
        </div>
      </Container>
    </>
  );
}
